import { minimalErrorEvent } from "src/utils/minimal-error-event";
import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import * as Sentry from "@sentry/react";
import App from "./app";
import { installPreloadRecovery } from "src/utils/preload-recovery";

// ----------------------------------------------------------------------

if (import.meta.env.VITE_E2E !== "true") {
  Sentry.init({
    dsn: "https://dc6133e0f4b3449d1e7ff287719f3059@o4511494826229760.ingest.de.sentry.io/4511494829834320",

    environment: import.meta.env.VITE_APP_VERSION,
    release: import.meta.env.VITE_APP_VERSION || "local",

    // FS-2026-065: operator chose minimal error reporting, no replay/tracing.
    sendDefaultPii: false,
    maxBreadcrumbs: 0,
    integrations: (defaults) => defaults.filter((item) =>
      !["BrowserSession", "Breadcrumbs"].includes(item.name)),
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend: minimalErrorEvent,
  });
}

if (import.meta.env.PROD) {
  installPreloadRecovery({
    buildId: import.meta.url,
    target: window,
    getStorage: () => window.sessionStorage,
    isOnline: () => navigator.onLine !== false,
    reload: () => window.location.reload(),
    report: (error, recovery) => Sentry.captureException(error, {
      tags: { source: "vite.preloadError", recovery },
    }),
  });
}

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container #app not found");
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
